import { render, staticRenderFns } from "./fixtureList.vue?vue&type=template&id=9d35b43a&scoped=true&"
import script from "./fixtureList.vue?vue&type=script&lang=ts&"
export * from "./fixtureList.vue?vue&type=script&lang=ts&"
import style0 from "./fixtureList.vue?vue&type=style&index=0&id=9d35b43a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d35b43a",
  null
  
)

export default component.exports